import { render, staticRenderFns } from "./rounds.vue?vue&type=template&id=66d4aac9"
import script from "./rounds.vue?vue&type=script&lang=js"
export * from "./rounds.vue?vue&type=script&lang=js"
import style0 from "./rounds.vue?vue&type=style&index=0&id=66d4aac9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports